// extracted by mini-css-extract-plugin
export default {"raceStats":"RaceStatistic_raceStats__FjQ8h"};